import React from 'react';
import ReactDOM from 'react-dom/client';
import '@arco-design/web-react/dist/css/arco.css';
import './index.css';
import './i18n'; // i18n debe inicializarse antes de App
import App from './App.jsx';
// IMPORTANTE: Importar api.js ANTES de AuthService para configurar axios globalmente
import './config/api';  // Esto configura el interceptor global de axios
import authService from './modules/auth/AuthService';

// AuthService ya está inicializado con interceptores configurados

// Fix definitivo para el error de ResizeObserver con Arco Design
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args && args.length && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
    return;
  }
  resizeObserverErr(...args);
};

// También prevenir el error desde la raíz
if (window.ResizeObserver) {
  const ro = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends ro {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Handler adicional para prevenir cualquier error restante
window.addEventListener('error', function(event) {
  if (event && event.message && (
    event.message.includes('ResizeObserver loop') ||
    event.message.includes('ResizeObserver')
  )) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
